import React, { useEffect, useRef } from 'react'
import aadhaar from "../../../assets/images/image 5.png"

function VerificationOtp({ OtpOnchange, handleSubmit, otp, setOtp }) {

  const inputRefs = [useRef(), useRef(), useRef(), useRef(), useRef(), useRef()];
  useEffect(() => {
    setOtp(['', '', '', '', '', '']);
  }, [])
  useEffect(() => {
    // Focus the first empty input when the component is initially rendered
    const firstEmptyInput = inputRefs.find((ref, index) => otp[index] === '');
    if (firstEmptyInput) {
      firstEmptyInput.current.focus();
    }
  }, [otp]);

  const handleBackspace = (e, index) => {
    if (e.key === 'Backspace' && index > 0 && otp[index] === '') {
      // Move focus to the previous input if Backspace is pressed on an empty input
      inputRefs[index - 1].current.focus();
    }
  };


  return (
    <div className="">
      <div className='d-flex flex-column flex-md-row align-items-center'>
        <div>
          <img src={aadhaar} />
        </div>
        {/* <p className="text_gray4 font_14 fw_500">Please enter the OTP you have received</p> */}
        <div className="">


          <div className="form_bx_stack ">

            {/* <div className="data mb-2 d-flex justify-content-center align-items-center gap-1 gap-sm-2 otp_custom_fields">
                  {/* <input type="text" className="form-control hide_arrows text-center  font_16 px-1 max_w_50x" />
                  <input type="tel" className="form-control hide_arrows text-center  font_16 px-1 max_w_50x" />
                  <input type="tel" className="form-control hide_arrows text-center   font_16 px-1 max_w_50x" />
                  <input type="tel" className="form-control hide_arrows text-center   font_16 px-1 max_w_50x" />
                  <input type="tel" className="form-control hide_arrows text-center   font_16 px-1 max_w_50x" />
                  <input type="tel" className="form-control hide_arrows text-center   font_16 px-1 max_w_50x" /> 
        <input type="text" className="form-control rounded-pill text-center ls_10x fw_600" name='Otp' maxLength={6} onChange={OtpOnchange}/>
              </div> */}
            <div className="mt-3 mt-md-0 data mb-2 d-flex justify-content-center align-items-center gap-1 gap-sm-2 otp_custom_fields">
              {otp.map((value, index) => (
                <input
                  key={index}
                  type="text"
                  className="form-control hide_arrows text-center   font_16 px-1 max_w_50x"
                  maxLength={1}
                  value={value} // Bind the value to the otp array element
                  onChange={(e) => OtpOnchange(e, index)}
                  onKeyDown={(e) => handleBackspace(e, index)}
                  ref={inputRefs[index]}
                  // Use autoFocus to focus on the first empty input
                  autoFocus={value === '' && index === 0}
                />
              ))}
            </div>
            <button
              type="submit"
              className="mt-2 mt-md-0 btn px_btn btn-master2 px-4 w-100 fw_500"
              onClick={handleSubmit}
            >
              Verify OTP
            </button>
          </div>
        </div>
      </div>
    </div>

  )
}

export default VerificationOtp
